import {allRouteDefinitions} from '../routing.config';
import getRouteKey from './getRouteKey';

function getDisplayNameForUrl(url: string): string {
  const path = url.split('?')[0];
  const routeKey = getRouteKey(path);

  return (routeKey && allRouteDefinitions[routeKey]?.displayName) || url;
}

export default getDisplayNameForUrl;
